import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { StatusCard } from '../models/status-card';
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';
import { AwsTrackingService } from 'app/common/tracking/aws-tracking.service';
import { EventDetails } from './../../common/tracking/aws-tracker';

@Component({
  selector: 'zest-status-card',
  templateUrl: './status-card.component.html',
  styleUrls: ['./status-card.component.scss'],
  animations: [
    trigger('heading', [
      state('in', style({ transform: 'translateY(0)', opacity: 1 })),
      transition('void => *', [
        style({ transform: 'translateY(20px)', opacity: 0 }),
        animate(200)
      ]),
      transition('* => void', [
        animate(200, style({ transform: 'translateY(-20px)', opacity: 0 }))
      ])
    ])
  ]
})
export class StatusCardComponent implements OnInit, OnDestroy {

  @Input() statusCard: StatusCard;
  @Input() declinedReason: string;

  @Output() action: EventEmitter<boolean> = new EventEmitter<boolean>();

  heading = [];
  headingsArray = [
    'Buy your favourite product now, pay later in easy EMIs!',
    'One credit limit to help you shop across 1000+ merchants',
    'Shopping in Amazon, Flipkart, MakeMytrip? Now pay in EMIs!',
    'Booking flights, hotels or packages? Get 0% interest EMI',
    'Use your credit limit to purchase electronics, fashion & more'
  ];
  headingChangeInterval: number;
  showVideo: boolean;

  constructor(
    private awsTrackingService: AwsTrackingService
  ) { }

  ngOnInit() {
    // Loop through the headings on get started card
    if (this.statusCard.cardType === 0) {
      setTimeout(() => {
        this.loopHeadings();
      }, 500);
    }
  }

  loopHeadings() {
    let count = 0;
    this.heading.push(this.headingsArray[count]);
    this.headingChangeInterval = window.setInterval(() => {
      if (this.heading.length) {
        this.heading.pop();
      }
      if (count === this.headingsArray.length - 1) {
        count = 0;
      } else {
        count++;
      }
      setTimeout(() => {
        this.heading.push(this.headingsArray[count]);
      }, 200);
    }, 5000);
  }

  toggleVideoPlayer() {
    this.showVideo = !this.showVideo;
    if (this.showVideo) {
      this.logEvent('ocd_learn_works');
    }
  }

  continue() {
    let eventName = '';
    this.action.emit(true);
    // Track the click event for Analytics
    switch (this.statusCard.name) {
      case 'get_started': {
        eventName = 'ocd_get_started_click';
        break;
      }
      case 'pd_done': {
        eventName = 'ocd_ed_next_continue_click';
        break;
      }
      case 'r1_done': {
        eventName = 'ocd_iv_next_continue_click';
        break;
      }
      case 'iv_done': {
        eventName = 'ocd_bd_next_continue_click';
        break;
      }
      case 'r2_approved':
      case 'r2_referred_kyc_pending': {
        eventName = 'ocd_complete_kyc_click';
        break;
      }
      case 'r2_approved_kyc_done': {
        eventName = 'ocd_activate_cl_click';
        break;
      }
      case 'cl_active': {
        eventName = 'ocd_shop_active_cl_click';
        break;
      }
      case 'cl_expired': {
        eventName = 'ocd_reactivate_click';
        break;
      }
    }
    this.logEvent(eventName);
  }

  ngOnDestroy() {
    window.clearInterval(this.headingChangeInterval);
  }

  logEvent(eventName, eventType = 'event', eventValue = 'triggered') {
    const event = new EventDetails(eventName, eventType, eventValue);
    this.awsTrackingService.sendDataToFunnel(event).subscribe();
    if (eventName === 'ocd_complete_kyc_click') {
      // this.awsTrackingService.trackMoengageEvent(eventName);
    }
    if (eventType === 'page') {
      this.awsTrackingService.gtmPageLoadEvent(eventName);
    } else {
      this.awsTrackingService.gtmTriggerEvent(eventName);
    }
  }

}
